export const getEmailFormData = (formData, values) => {
  const {
    label,
    subject,
    body,
    attachments,
    from,
    cc,
    bcc,
    ats_comm_template_id = '',
    ats_shared_email_id = undefined,
  } = values;
  let hasTemplateAttachments = false;
  formData.append('label', label);
  formData.append('kind', 'email');

  if (from) {
    formData.append('candidate_comm_sender_id', from);
  }
  formData.append('candidate_comm_template_attributes[subject]', subject);
  formData.append('candidate_comm_template_attributes[body]', body);
  formData.append('candidate_comm_template_attributes[channel]', 'email');
  if (ats_shared_email_id) {
    formData.append('ats_shared_email_id', ats_shared_email_id);
  }

  cc?.forEach((id) => {
    formData.append('cc_participant_ids[]', id);
  });
  bcc?.forEach((id) => {
    formData.append('bcc_participant_ids[]', id);
  });
  attachments.forEach((file) => {
    if (file instanceof File) {
      formData.append(
        'candidate_comm_template_attributes[attachments][]',
        file
      );
    }
    if (file?.id) {
      hasTemplateAttachments = true;
      formData.append(
        'candidate_comm_template_attributes[attachments][]',
        file?.id
      );
    }
  });

  if (attachments?.length === 0) {
    formData.append('candidate_comm_template_attributes[attachments][]', []);
  }
  if (hasTemplateAttachments && ats_comm_template_id) {
    formData.append('ats_comm_template_id', ats_comm_template_id);
  }
  return formData;
};

export const getSurveyFormData = (formData, values) => {
  const {
    label,
    subject,
    body,
    attachments = [],
    from,
    cc = [],
    bcc = [],
    survey_id = '',
    ats_comm_template_id = '',
    ats_shared_email_id = undefined,
    survey_type = 'survey',
    toAddress,
    email_template_name = '',
  } = values;
  let hasTemplateAttachments = false;
  formData.append('label', label);
  formData.append('kind', 'survey');
  formData.append('mode', 'manual');
  if (from) {
    formData.append('candidate_comm_sender_id', from);
  }

  if (ats_shared_email_id) {
    formData.append('ats_shared_email_id', ats_shared_email_id);
  }

  formData.append('survey_type', survey_type);
  formData.append('ats_form_template_id', survey_id);

  formData.append('[candidate_comm_template_attributes][subject]', subject);
  formData.append('[candidate_comm_template_attributes][body]', body);
  if (email_template_name) {
    formData.append('email_template_name', email_template_name);
  }
  // formData.append(
  //   'ats_comm_template_association_attributes[ats_comm_template_attributes][channel]',
  //   'email'
  // );

  cc?.forEach((id) => {
    formData.append('cc_participant_ids[]', id);
  });
  bcc?.forEach((id) => {
    formData.append('bcc_participant_ids[]', id);
  });
  toAddress?.forEach((id) => {
    formData.append('to_participant_ids[]', id);
  });
  attachments.forEach((file) => {
    if (file instanceof File) {
      formData.append(
        'candidate_comm_template_attributes[attachments][]',
        file
      );
    }
    if (file?.id) {
      hasTemplateAttachments = true;
      formData.append(
        'candidate_comm_template_attributes[attachments][]',
        file?.id
      );
    }
  });

  if (attachments?.length === 0) {
    formData.append('candidate_comm_template_attributes[attachments][]', []);
  }

  if (hasTemplateAttachments && ats_comm_template_id) {
    formData.append('ats_comm_template_id', ats_comm_template_id);
  }
  return formData;
};

export const getAssessmentFormData = (formData, values) => {
  const {
    label,
    assessment,
    assessment_upload,
    reviewer_ids,
    // ! assessment commenting for V1
    // subject,
    // body,
    // attachments = [],
    // from = [],
    // cc = [],
    // bcc = [],
    scoreCards = [
      {
        question: '',
        mandatory: false,
        description: '',
      },
    ],
    platform = 'internal',
    kind = 'assessment',
    reviewer_attachments = [],
    reviewer_instructions = '',
    scorecardId = null,
    feedback_description = '',
    is_feedback_mandatory = false,
    rating_description = '',
    ext_test_id = '',
    ext_test_name = '',
    ext_assessment_link = '',
    scorecard_required = true,
  } = values;

  // Details
  formData.append('label', label);
  formData.append('kind', kind);
  formData.append('assessment_template_attributes[name]', label);
  formData.append('assessment_template_attributes[text]', assessment);
  // Only append external assessment fields for external platforms
  if (platform !== 'internal') {
    if (ext_test_id?.value) {
      formData.append(
        'assessment_template_attributes[ext_test_id]',
        ext_test_id.value
      );
    }
    if (ext_test_name) {
      formData.append(
        'assessment_template_attributes[ext_test_name]',
        ext_test_name
      );
    }
    if (ext_assessment_link) {
      formData.append(
        'assessment_template_attributes[ext_assessment_link]',
        ext_assessment_link
      );
    }
  }
  assessment_upload?.forEach((file) => {
    if (file instanceof File) {
      formData.append('assessment_template_attributes[attachments][]', file);
    }
    if (file?.id) {
      formData.append(
        'assessment_template_attributes[attachments][]',
        file?.id
      );
    }
  });
  if (assessment_upload?.length === 0) {
    formData.append('assessment_template_attributes[attachments][]', []);
  }
  reviewer_attachments?.forEach((file) => {
    if (file instanceof File) {
      formData.append(
        'assessment_template_attributes[reviewer_instructions_attachments][]',
        file
      );
    }
    if (file?.id) {
      formData.append(
        'assessment_template_attributes[reviewer_instructions_attachments][]',
        file?.id
      );
    }
  });
  formData.append('assessment_template_attributes[platform]', platform);
  formData.append('scorecard_required', scorecard_required);
  const jobTitles = new Set([
    'job_hiring_manager',
    'job_recruiter',
    'job_coordinator',
  ]);
  const participant_groups = [];
  const participant_ids = [];

  reviewer_ids.forEach((item) => {
    (jobTitles.has(item) ? participant_groups : participant_ids).push(item);
  });

  participant_ids.forEach((id) => formData.append('participant_ids[]', id));
  participant_groups.forEach((id) =>
    formData.append('participant_groups[]', id)
  );
  if (reviewer_instructions) {
    formData.append(
      'assessment_template_attributes[reviewer_instructions]',
      reviewer_instructions
    );
  }

  if (scorecard_required) {
    if (scorecardId) formData.append('children[0][id]', scorecardId);
    formData.append('children[0][kind]', 'scorecard');
    formData.append(
      'children[0][feedback_description]',
      feedback_description || ''
    );
    formData.append(
      'children[0][is_feedback_mandatory]',
      is_feedback_mandatory
    );
    formData.append(
      'children[0][rating_description]',
      rating_description || ''
    );
    scoreCards?.forEach((scorecard, index) => {
      if (!scorecard?.question) return;
      formData.append(
        `children[0][questions][${index}][question]`,
        scorecard?.question
      );
      formData.append(
        `children[0][questions][${index}][type]`,
        scorecard?.type
      );
      formData.append(
        `children[0][questions][${index}][mandatory]`,
        scorecard?.mandatory || false
      );
      formData.append(
        `children[0][questions][${index}][description]`,
        scorecard?.description || ''
      );
      scorecard?.options?.forEach((option) => {
        formData.append(
          `children[0][questions][${index}][options][]`,
          option?.optionText || option
        );
      });
    });
  } else {
    formData.append('children[]', '');
  }

  // ! assessment commenting for V1
  // Email
  // formData.append('children[1][kind]', 'email');
  // formData.append('children[1][candidate_comm_sender_id]', from);
  // formData.append(
  //   'children[1][candidate_comm_template_attributes][subject]',
  //   subject
  // );
  // formData.append(
  //   'children[1][candidate_comm_template_attributes][body]',
  //   body
  // );
  // formData.append(
  //   'children[1][candidate_comm_template_attributes][channel]',
  //   'email'
  // );
  // cc?.forEach((id) => {
  //   formData.append('children[1][cc_participant_ids][]', id);
  // });
  // bcc?.forEach((id) => {
  //   formData.append('children[1][bcc_participant_ids][]', id);
  // });
  // attachments?.forEach((file) => {
  //   if (file instanceof File) {
  //     formData.append(
  //       'children[1][candidate_comm_template_attributes][attachments][]',
  //       file
  //     );
  //   }
  //   if (file?.id) {
  //     formData.append(
  //       'children[1][candidate_comm_template_attributes][attachments][]',
  //       file?.id
  //     );
  //   }
  // });
  return formData;
};
